// 模块Sheet组件
"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { MobileHeader } from "@/components/ui/mobile-header";
import { PullToRefreshWrapper } from "@/components/ui/pull-to-refresh";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
interface ModuleSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  className?: string;
  disableDrag?: boolean;
  onRefresh?: () => Promise<void>;
  disableRefresh?: boolean;
  contentClassName?: string;
  disableAnimation?: boolean;
  rightContent?: React.ReactNode;
}
export function ModuleSheet(t0) {
  const $ = _c(26);
  const {
    open,
    onOpenChange,
    title,
    children,
    className,
    onRefresh,
    disableRefresh: t1,
    contentClassName,
    disableAnimation: t2,
    rightContent
  } = t0;
  const disableRefresh = t1 === undefined ? false : t1;
  const disableAnimation = t2 === undefined ? false : t2;
  const contentRef = React.useRef(null);
  const handleContentTouchStart = _temp;
  let t3;
  if ($[0] !== contentClassName) {
    t3 = cn("flex-1 overflow-y-auto p-4 pb-16", contentClassName);
    $[0] = contentClassName;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div ref={contentRef} className={t3} onTouchStart={handleContentTouchStart}>{children}</div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const contentDom = t4;
  let t5;
  if ($[5] !== className) {
    t5 = cn("fixed inset-0 z-50 !h-100dvh !w-screen max-w-none rounded-none border-none bg-background p-0 !gap-0", className);
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== title) {
    t6 = <SheetTitle className="sr-only">{title}</SheetTitle>;
    $[7] = title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== rightContent || $[10] !== title) {
    t7 = <MobileHeader title={title} rightContent={rightContent} />;
    $[9] = rightContent;
    $[10] = title;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== contentDom || $[13] !== disableRefresh || $[14] !== onRefresh) {
    t8 = onRefresh && !disableRefresh ? <PullToRefreshWrapper onRefresh={onRefresh} className="flex-1" disabled={disableRefresh}>{contentDom}</PullToRefreshWrapper> : contentDom;
    $[12] = contentDom;
    $[13] = disableRefresh;
    $[14] = onRefresh;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== disableAnimation || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <SheetContent side="right" showCloseButton={false} disableAnimation={disableAnimation} id="module-sheet-content" className={t5}>{t6}{t7}{t8}</SheetContent>;
    $[16] = disableAnimation;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onOpenChange || $[23] !== open || $[24] !== t9) {
    t10 = <Sheet open={open} onOpenChange={onOpenChange}>{t9}</Sheet>;
    $[22] = onOpenChange;
    $[23] = open;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp(event) {
  const target = event.target as HTMLElement;
  const scrollableElement = target.closest("[data-carousel-container], [style*=\"touch-action\"]");
  if (scrollableElement) {
    return;
  }
}
export function fixModuleSheetViewport() {
  const content = document.getElementById("module-sheet-content");
  if (content) {
    content.style.height = "99.9dvh";
  }
  requestAnimationFrame(() => {
    if (content) {
      content.style.height = "100dvh";
    }
  });
}